import { RouterLink, type RouterLinkProps } from 'vue-router'

const isExternal = (to: string | object) => typeof to === 'string' && /^(?:https?:|mailto:|tel:)/.test(to)

/**
 * Check the console output for invalid routes (type-safe routes coming soon: #2522)
 * @param to
 * @param options
 * @example
 * <Link v-bind="to({ name: 'about' }, { replace: true })">
 * <Link v-bind="to('https://open.audio/')">
 * @see https://dev.funkwhale.audio/funkwhale/funkwhale/-/issues/2522
 */
export const to = (to: RouterLinkProps['to'], options?: Omit<RouterLinkProps, 'to'>) => isExternal(to) ? ({
  is: 'a',
  href: to as string,
  target: '_blank',
  rel: 'noopener noreferrer',
  ...options
}) as const : ({
  is: RouterLink,
  to,
  activeClass: '',
  exactActiveClass: '',
  ...options
})
